<template>
  <div class="list-search">
    <form>
      <div class="row row-clear-sm-6-md-4">
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <label class="sr-only">Keywords</label>

            <input name="keywords" v-model="stateKeywords" type="text" class="form-control" placeholder="Keywords" />
          </div>
        </div>
        <div class="col-sm-6 col-md-4" v-if="$userIsGlobalAdmin && regionOptions.length > 1">
          <div class="form-group">
            <label class="sr-only">Region</label>
            <selectize
              ref="regions"
              class="selectize selectize-multiple"
              multiple
              name="region"
              v-model="stateRegions"
              placeholder="Region"
              :options="regionOptions"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4" v-if="!$userIsClient">
          <div class="form-group">
            <label class="sr-only">Due</label>
            <div class="input-group">
              <flatpickr
                v-model="dateRange"
                :config="flatPickerDateConfig"
                placeholder="Date"
                class="form-control"
                name="date_range"/>

              <span class="input-group-addon" data-toggle>
                <i class="fa fa-calendar"></i>
              </span>

              <span class="input-group-addon" data-clear>
                <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-md-4" v-if="$userIsManager">
          <div class="form-group">
            <label class="sr-only">{{ $starLabelPlural | sentenceCase }}</label>
            <selectize
              ref="talent"
              class="selectize selectize-multiple"
              multiple
              name="talent"
              v-model="stateTalent"
              :placeholder="$options.filters.sentenceCase($starLabel)"
              :options="talentOptions"
              :pre-load="true"
              :fetch-results="fetchTalentCallback"
              :fetch-more-results="fetchMoreTalentCallback"/>
          </div>
        </div>
        <div class="col-sm-6 col-md-4" v-if="$userIsAdmin">
          <div class="form-group">
            <label class="sr-only">Request Number</label>

            <input name="id" v-model="stateId" type="text" class="form-control" placeholder="Request Number" />
          </div>
        </div>
        <div :class="buttonClass">
          <div class="form-group">
            <slot name="button"/>

            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { stateMapper } from 'mixins/bookings/filters'
import { mapActions, mapState } from 'vuex'
import { map } from 'lodash'
import Selectize from '../ext/codium/CodiumSelectize'
import Flatpickr from 'vue-flatpickr-component'

export default {
  mixins: [stateMapper],

  props: {
    setFilterMutation: {
      required: true,
      type: Function
    },
    filters: {
      required: true,
      type: Object
    },
    applyFilters: {
      required: false,
      type: Function
    }
  },

  components: {
    Selectize,
    Flatpickr
  },

  data () {
    return {
      opportunityOptions: [],
      locationOptions: [],
      regionOptions: [],
      flatPickerDateConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range'
      }
    }
  },

  computed: {
    ...mapState('talent', ['talents']),

    buttonClass () {
      let buttonClass = 'text-right pull-right'
      if (this.$userIsAdmin) {
        return 'col-sm-6 ' + buttonClass
      }
      if (this.$userIsManager) {
        return 'col-sm-12 ' + buttonClass
      }
      return 'col-sm-6 col-md-4'
    },

    dateRange: {
      get () {
        if (this.stateDateFrom === null || this.stateDateTo === null) {
          return null
        }

        return [this.stateDateFrom, this.stateDateTo]
      },

      set (value) {
        if (value === null || value === undefined) {
          this.stateDateFrom = null
          this.stateDateTo = null
        } else {
          [this.stateDateFrom, this.stateDateTo] = value.split(' to ')
        }
      }
    },

    talentOptions () {
      return map(this.talents, talent => ({ id: talent.id, text: talent.name }))
    }
  },

  created () {
    this.getOpportunities()
      .then((response) => {
        this.opportunityOptions = map(response.data, opportunity => ({ id: opportunity.id, text: opportunity.name }))
      })

    this.getLocations()
      .then((response) => {
        this.locationOptions = map(response.data, location => ({ id: location.shortname, text: location.shortname }))
      })

    if (this.$userIsGlobalAdmin && !this.$vlastMode) {
      this.getRegions()
        .then((response) => {
          this.regionOptions = map(response.data, region => ({id: region.id, text: region.name}))
          this.stateRegions = [this.$user.region_id]
          if (this.applyFilters) {
            this.applyFilters()
          }
        })
    }
  },

  methods: {
    ...mapActions('region', ['getRegions']),
    ...mapActions('location', ['getLocations']),
    ...mapActions('opportunity', ['getOpportunities']),
    ...mapActions('talent', ['getTalents', 'getNextTalents']),

    fetchTalentCallback (name, callback) {
      return this.getTalents({ name })
        .then(() => {
          callback(this.talentOptions)
        })
    },

    fetchMoreTalentCallback (name, callback) {
      return this.getNextTalents({ name })
        .then(() => {
          callback(this.talentOptions)
        })
        .catch(() => {})
    }
  }
}
</script>
